class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupAboutMenuHover();
  }

  setupAboutMenuHover() {
    if (!this.classList.contains('about-menu')) return;

    this.aboutSubmenu = this.mainDetailsToggle.querySelector('.header__submenu--about');
    this.aboutSummary = this.mainDetailsToggle.querySelector('summary');
    this.aboutMenuCloseTimer = null;
    this.aboutMenuMediaQuery = window.matchMedia('(min-width: 990px)');

    this.isPointerInAboutCorridor = (x, y) => {
      if (!this.aboutSummary || !this.aboutSubmenu) return false;

      const summaryRect = this.aboutSummary.getBoundingClientRect();
      const submenuRect = this.aboutSubmenu.getBoundingClientRect();
      const headerBottom = this.header ? this.header.getBoundingClientRect().bottom : submenuRect.top;

      if (y < summaryRect.top - 6 || y > submenuRect.bottom) return false;

      if (y >= headerBottom - 12) {
        return x >= submenuRect.left && x <= submenuRect.right;
      }

      const horizontalPad = 40;
      return (
        x >= summaryRect.left - horizontalPad &&
        x <= summaryRect.right + horizontalPad &&
        y <= headerBottom
      );
    };

    this.isPointerInAboutZone = (x, y) => {
      if (!this.mainDetailsToggle.hasAttribute('open')) return false;

      const el = document.elementFromPoint(x, y);
      if (el) {
        if (this.aboutSummary.contains(el) || this.aboutSubmenu.contains(el)) return true;
        if (el.closest('.header__submenu--about')) return true;
      }

      return this.isPointerInAboutCorridor(x, y);
    };

    this.openAboutMenu = () => {
      if (!this.aboutMenuMediaQuery.matches) return;

      window.clearTimeout(this.aboutMenuCloseTimer);
      this.mainDetailsToggle.setAttribute('open', '');
      this.aboutSummary.setAttribute('aria-expanded', true);
      this.onToggle();
    };

    this.cancelAboutMenuClose = () => {
      window.clearTimeout(this.aboutMenuCloseTimer);
    };

    this.scheduleAboutMenuClose = () => {
      window.clearTimeout(this.aboutMenuCloseTimer);
      this.aboutMenuCloseTimer = window.setTimeout(() => {
        if (this.lastPointer && this.isPointerInAboutZone(this.lastPointer.x, this.lastPointer.y)) return;
        this.close();
      }, 400);
    };

    this.trackAboutMenuPointer = (event) => {
      this.lastPointer = { x: event.clientX, y: event.clientY };

      if (!this.aboutMenuMediaQuery.matches || !this.mainDetailsToggle.hasAttribute('open')) return;

      if (this.isPointerInAboutZone(event.clientX, event.clientY)) {
        this.cancelAboutMenuClose();
      } else {
        this.scheduleAboutMenuClose();
      }
    };

    this.bindAboutMenuHover = () => {
      this.aboutSummary?.removeEventListener('mouseenter', this.openAboutMenu);
      document.removeEventListener('mousemove', this.trackAboutMenuPointer);

      if (!this.aboutMenuMediaQuery.matches) return;

      this.aboutSummary?.addEventListener('mouseenter', this.openAboutMenu);
      document.addEventListener('mousemove', this.trackAboutMenuPointer);
    };

    this.bindAboutMenuHover();
    this.aboutMenuMediaQuery.addEventListener('change', this.bindAboutMenuHover);
  }

  onFocusOut() {
    if (this.classList.contains('about-menu') && this.aboutMenuMediaQuery?.matches) return;
    super.onFocusOut();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);